import styled from "styled-components";
import {
  bob,
  colors,
  easing,
  fadeIn,
  fadeUp,
  fonts,
  layout,
  media,
  zoomOut,
} from "../../../theme";
import { Eyebrow } from "../../general/Typography";

export const HeroContainer = styled.header`
  position: relative;
  display: flex;
  align-items: center;
  min-height: 100vh;
  min-height: 100svh;
  overflow: hidden;
  background-color: ${colors.secondary};
`;

export const HeroImage = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center 60%;
  animation: ${zoomOut} 2.8s ${easing.out} both;
`;

export const HeroOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(
      180deg,
      rgba(28, 28, 28, 0.6) 0%,
      rgba(28, 28, 28, 0) 30%
    ),
    linear-gradient(
      90deg,
      rgba(28, 28, 28, 0.85) 0%,
      rgba(28, 28, 28, 0.55) 45%,
      rgba(28, 28, 28, 0.15) 100%
    );

  ${media.mobile} {
    background: linear-gradient(
      180deg,
      rgba(28, 28, 28, 0.65) 0%,
      rgba(28, 28, 28, 0.55) 50%,
      rgba(28, 28, 28, 0.75) 100%
    );
  }
`;

export const HeroContent = styled.div`
  position: relative;
  width: 100%;
  max-width: ${layout.maxWidth};
  margin: 0 auto;
  padding: calc(${layout.navHeight} + 2rem) ${layout.gutter} 7rem;
`;

export const HeroEyebrow = styled(Eyebrow)`
  animation: ${fadeUp} 0.9s ${easing.out} 0.2s both;
`;

export const HeroTitle = styled.h1`
  max-width: 12ch;
  margin: 1.25rem 0 1.25rem;
  font-size: clamp(3rem, 8vw, 6rem);
  line-height: 1.02;
  color: ${colors.primary};
  animation: ${fadeUp} 0.9s ${easing.out} 0.35s both;
`;

export const HeroSubtitle = styled.p`
  max-width: 32rem;
  font-family: ${fonts.heading};
  font-style: italic;
  font-size: clamp(1.15rem, 2.2vw, 1.6rem);
  line-height: 1.45;
  color: rgba(255, 255, 234, 0.92);
  animation: ${fadeUp} 0.9s ${easing.out} 0.5s both;
`;

export const HeroActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-top: 2.5rem;
  animation: ${fadeUp} 0.9s ${easing.out} 0.65s both;
`;

export const ScrollCue = styled.button`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 6rem;
  display: grid;
  place-items: center;
  width: 2.75rem;
  height: 2.75rem;
  margin: 0 auto;
  border: 1px solid rgba(255, 255, 234, 0.4);
  border-radius: 50%;
  background: none;
  color: ${colors.backgroundMain};
  font-size: 1.25rem;
  cursor: pointer;
  animation: ${fadeIn} 0.8s ease 1.1s both,
    ${bob} 2.4s ease-in-out 2s infinite;
  transition: background-color 0.3s ease, color 0.3s ease,
    border-color 0.3s ease;

  &:hover {
    background-color: ${colors.primary};
    border-color: ${colors.primary};
    color: ${colors.secondary};
  }

  ${media.mobile} {
    bottom: 4.75rem;
  }
`;
